// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */
export enum ClaimActivityType {
    WELCOMEPAGE = 'TENANT_VIEWED_WELCOME_PAGE',
    INITIALCHARGES = 'TENANT_VIEWED_INITIAL_CHARGES',
    REVIEWCHARGES = 'TENANT_VIEWED_REVIEW_CHARGES',
    SUBMITPROPOSALMODAL = 'TENANT_VIEWED_SUBMIT_PROPOSAL_MODAL',
    PROPOSALPAYMENTPAGE = 'TENANT_VIEWED_PROPOSAL_PAYMENT_PAGE',
    ACCEPTCHARGESMODAL = 'TENANT_VIEWED_ACCEPT_CHARGES_MODAL',
    ACCEPTCHARGESPAYMENTPAGE = 'TENANT_VIEWED_ACCEPT_CHARGES_PAYMENT_PAGE',
    CHECKOUTINVENTORYREPORT = 'TENANT_VIEWED_CHECKOUT_INVENTORY_REPORT'
}



